import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  loadUsers,
  loadActiveUsers,
  loadPartnerCompany,
  loadActivePartnerCompany,
  loadAffiliates,
  loadActiveAffiliates,
  loadNetworks,
  loadPartnersApi,
} from 'scenes/ApiIntegrations/sources/fields';

import OpenCostPeriodCampaigns from './OpenCostPeriodCampaigns';
import {
  NAME,
  OWNER,
  PARTNER_COMPANY,
  AFFILIATES,
  NETWORKS,
  INTEGRATED_PARTNER,
  INTEGRATION_START_DATE,
} from './constants';
import { ApiIntegrationFormValidationSchema } from './schemas';

const ApiIntegrationForm = withForm({
  validationSchema: ApiIntegrationFormValidationSchema,
  enableReinitialize: true,
})(({
  children,
  title,
  subTitle,
  loading,
  onClose,
  onExited,
  open,
  isEdit,
  entityId,
}) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody>
        <Section title={'General'}>
          <Grid container wrap={'wrap'} spacing={3}>
            <Grid item xs={4}>
              <FormField.TextField
                label={'Name'}
                name={NAME}
                required={true}
                padding={0}
                placeholder={'Commercial or brand name'}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Owner'}
                name={OWNER}
                padding={0}
                required={true}
                source={isEdit ? loadUsers : loadActiveUsers}
                lazy={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Partner company'}
                name={PARTNER_COMPANY}
                padding={0}
                source={isEdit ? loadPartnerCompany : loadActivePartnerCompany}
                lazy={true}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.MultiSelect
                label={'Affiliates'}
                name={AFFILIATES}
                padding={0}
                depends={[PARTNER_COMPANY]}
                source={isEdit ? loadAffiliates : loadActiveAffiliates}
                lazy={true}
                required={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.MultiSelect
                label={'Networks'}
                basis={'50%'}
                name={NETWORKS}
                padding={0}
                source={loadNetworks}
                lazy={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Integrated partner'}
                name={INTEGRATED_PARTNER}
                padding={0}
                source={loadPartnersApi}
                lazy={true}
                required={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.DatePicker
                label={'Integration start date'}
                name={INTEGRATION_START_DATE}
                padding={0}
                required={true}
              />
            </Grid>
          </Grid>
        </Section>
        <OpenCostPeriodCampaigns />
      </SidePageV2.NewBody>

      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default ApiIntegrationForm;
